//React
import { FunctionComponent, useEffect, useRef, useState } from "react";

//Interfaces
import { SortOptions } from "../../models/sorting/sort-options";
import { SortOptionMap } from "../../models/sorting/sort-option-map";

//Actions
import {
	clearCurrentSort,
	setCurrentSort,
} from "../../redux/slices/result-list-slice";

//App Hooks
import {
	useAppDispatch,
	useAppSelector,
} from "../../../system/redux/hooks/redux-store-hooks";

//Util
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";

//Selectors
import { selectCurrentSort } from "../../redux/selectors/sorting/select-current-sort";

import SortLink from "./sort-link";

const SortMenu: FunctionComponent = (props) => {
	//Store Dispatch
	const dispatch = useAppDispatch();

	//State Values
	const currentSort = useAppSelector(selectCurrentSort);

	const [open, setOpen] = useState(false);

	const componentRef = useRef(null);

	//Make it so the sort menu closes when you click outside the component.
	useEffect(() => {
		if (!open) {
			return;
		}

		const handleClickOutside = (event) => {
			if (
				componentRef.current &&
				!componentRef.current.contains(event.target)
			) {
				// If the clicked element is not inside the component, close it
				setOpen(false);
			} else {
			}
		};

		document.addEventListener("mousedown", handleClickOutside); // Use 'mousedown' for better responsiveness

		return () => {
			// Clean up the event listener when the component unmounts
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [open]);

	const getOptionClass = function (optionId: string) {
		let className = "sort-option";

		if (optionId === currentSort) {
			className += " selectedSortingOption";
		}

		return className;
	};

	if (!open) {
		return (
			<button
				className="community-set__sort-by-cf"
				type="button"
				onClick={() => setOpen(!open)}
			>
				<svg
					className={open ? "flip" : ""}
					aria-hidden="true"
					role="img"
					focusable="false"
					width="12"
					height="15"
					viewBox="0 0 16 12"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g
						transform="translate(4 2)"
						stroke="currentColor"
						strokeWidth="1.3"
						fill="none"
						fillRule="evenodd"
						strokeLinecap="square"
					>
						<path d="M10.95 1L6 5.95M1 1l4.95 4.95"></path>
					</g>
				</svg>

				<SortLink />
			</button>
		);
	} else {
		//JSX
		return (
			<span>
				<button
					className="community-set__sort-by-cf"
					type="button"
					onClick={() => setOpen(!open)}
				>
					<svg
						className={open ? "flip" : ""}
						aria-hidden="true"
						role="img"
						focusable="false"
						width="12"
						height="15"
						viewBox="0 0 16 12"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g
							transform="translate(4 2)"
							stroke="currentColor"
							strokeWidth="1.3"
							fill="none"
							fillRule="evenodd"
							strokeLinecap="square"
						>
							<path d="M10.95 1L6 5.95M1 1l4.95 4.95"></path>
						</g>
					</svg>

					<div
						aria-hidden="true"
						className="community-set__sort-menu"
						style={{ display: "block" }}
						ref={componentRef}
					>
						{!isStringEmpty(currentSort) && (
							<p
								className="sort-option"
								key="clear"
								id="clear"
								onClick={() => dispatch(clearCurrentSort())}
							>
								<span className="sort-option-title">Clear</span>
							</p>
						)}

						{Object.entries(SortOptions as SortOptionMap).map(
							([sortOptionId, sortOption]) => (
								<p
									className={getOptionClass(sortOptionId)}
									key={sortOptionId}
									id={sortOptionId}
									onClick={() => dispatch(setCurrentSort(sortOptionId))}
								>
									<span className="sort-option-title">
										{sortOption.Label}:{" "}
									</span>
									{sortOption.Type}
								</p>
							),
						)}
					</div>

					<SortLink />
				</button>
			</span>
		);
	}
};

export default SortMenu;
